// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".customCodeDisplay--3TUojcwC pre[class*=\"language-\"],\n  .customCodeDisplay--3TUojcwC code[class*=\"language-\"] {\n    font-size: 12px;\n    line-height: 16px;\n  }\n  .customCodeDisplay--3TUojcwC pre[class*=\"language-\"] {\n    padding-top: 4px;\n    padding-bottom: 4px;\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customCodeDisplay": "customCodeDisplay--3TUojcwC"
};
export default ___CSS_LOADER_EXPORT___;
